module.exports = __webpack_public_path__ + "img/neo-hpstr.a38062d9.png";